import { GatsbyImage } from 'gatsby-plugin-image';
import propType from 'prop-types';
import React from 'react';
import DynamicHero from '../DynamicHero';
import { MAPPING_CLASS_NAME_FOR_ARTICLE_TYPE } from '../../config/constant';

export default function ArticleHeader({ type, metadata }) {
  const { featuredImage = null, title, dateGmt } = metadata;
  return (
    <>
      <DynamicHero
        image={featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData}
        content={
          <header className="article-header">
            <div className="article-header__metadata">
              <div className="article-header__metadata__wrapper">
                <div
                  className="article-header__metadata__title"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
                <div className="article-header__metadata__created-date">
                  {dateGmt}
                </div>
              </div>
            </div>
          </header>
        }
      />
      <GatsbyImage
        image={featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData}
        alt=""
        className={`article-header__img ${MAPPING_CLASS_NAME_FOR_ARTICLE_TYPE[type]}`}
      />
    </>
  );
}

ArticleHeader.propTypes = {
  type: propType.oneOf(['blog', 'news']).isRequired,
  metadata: propType.shape({
    title: propType.string.isRequired,
    dateGmt: propType.string.isRequired,
    featuredImage: propType.shape({
      node: propType.shape({
        localFile: propType.shape({
          childImageSharp: propType.shape({
            gatsbyImageData: propType.shape({})
          })
        })
      })
    }).isRequired
  }).isRequired
};
